<div class="card border rounded">

  <div class="card-header flex-between">
    <ng-content select="[header]"></ng-content>
  </div>

  <div class="card-body">
    <ng-content select="[body]"></ng-content>

    @if (periodControl) {
      <div class="d-flex align-items-center mb-3">
        <span class="period-label">{{ 'charts.select_period' | translate }}</span>
        <input type="text"
          class="form-control-plaintext pointer col-2"
          bsDatepicker
          [bsConfig]="bsConfigStart"
          [value]="startDate | amDateFormat: 'MM YYYY'"
          [(bsValue)]="startDate"
          (bsValueChange)="updateDates()">
          <span>-</span>
          <input type="text"
            class="form-control-plaintext pointer col-2"
            bsDatepicker
            [bsConfig]="bsConfigEnd"
            [value]="endDate | amDateFormat: 'MM YYYY'"
            [(bsValue)]="endDate"
            (bsValueChange)="updateDates()">
          </div>
        }
        <div #cardBodyRef>
          @if (renderChart && !chartError) {
            @switch (chartType) {
              @case ('doughnet') {
                <ngx-charts-pie-chart [view]="view"
                  [results]="chartData"
                  scheme="picnic"
                  doughnut="true"
                  [legendPosition]="legendPosition"
                  [legend]="showLegend"
                  [labels]="showLabels"
                  (select)="onSelect($event)">
                </ngx-charts-pie-chart>
              }
              @case ('pie') {
                <ngx-charts-pie-chart [view]="view"
                  [results]="chartData"
                  scheme="picnic"
                  [legendPosition]="legendPosition"
                  [legend]="showLegend"
                  [labels]="showLabels"
                  (select)="onSelect($event)">
                </ngx-charts-pie-chart>
              }
              @case ('bar') {
                <ngx-charts-bar-horizontal [view]="view"
                  [results]="chartData"
                  scheme="picnic"
                  [xAxis]="true"
                  [yAxis]="true"
                  [showYAxisLabel]="true"
                  [showXAxisLabel]="true"
                  (select)="onSelect($event)">
                </ngx-charts-bar-horizontal>
              }
            }
          }

          @if (chartError) {
            <!--        <div class="alert alert-warning">{{ 'chart.error' | translate}}</div>-->
          }
        </div>
      </div>
    </div>
